import { ThemedText } from "@/components/ThemedText";

export default function NewPayrollPage() {
  return <ThemedText>New Payroll (Placeholder)</ThemedText>;
}
